import { QuoteListFilter } from '@features/invoices/enums/quoteListFilter'

export const QUOTES_SUMMARY_FILTERS_ORDER: QuoteListFilter[] = [
  QuoteListFilter.All,
  QuoteListFilter.Draft,
  QuoteListFilter.Pending,
  QuoteListFilter.Accepted,
  QuoteListFilter.Rejected,
  QuoteListFilter.Invoiced,
]
